import { reactive, watch } from 'vue'


interface Settings {
  mute: boolean
  popupMessage: boolean
  popupIllust: boolean
  popupUser: boolean
  pressureColor: number
  pressureWeight: number
  syncEraserBrush: boolean
  stabilization: number
  taperStart: number
  taperEnd: number
  undoMax: number
}

interface OldSettings20260906 {
  mute: boolean
  popup: boolean
  pressureColor: boolean
  pressureWeight: boolean
}

interface OldSettings20260908 {
  mute: boolean
  popupMessage: boolean
  popupIllust: boolean
  popupUser: boolean
  pressureColor: boolean
  pressureWeight: boolean
  syncEraserBrush: boolean
}

const KEY = 'settings'

// iPadOSのデスクトップ表示ではMacとして識別されるため、タッチ対応も確認する。
const isIPad = /iPad/.test(navigator.userAgent)
  || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
const DEFAULT_PRESSURE = isIPad ? 8 : 2

const migrateSettings = (settings: Settings | OldSettings20260906 | OldSettings20260908): Partial<Settings> => {
  if ('popup' in settings) {
    const { popup, ...rest } = settings
    return {
      popupMessage: popup,
      popupIllust: popup,
      popupUser: popup,
      syncEraserBrush: true,
      stabilization: 2,
      taperStart: 0,
      taperEnd: 0,
      ...rest,
      pressureColor: rest.pressureColor ? DEFAULT_PRESSURE : 0,
      pressureWeight: rest.pressureWeight ? DEFAULT_PRESSURE : 0
    }
  }
  return {
    ...settings,
    pressureColor: typeof settings.pressureColor === 'boolean' ? (settings.pressureColor ? DEFAULT_PRESSURE : 0) : settings.pressureColor,
    pressureWeight: typeof settings.pressureWeight === 'boolean' ? (settings.pressureWeight ? DEFAULT_PRESSURE : 0) : settings.pressureWeight,
    syncEraserBrush: settings.syncEraserBrush ?? true
  }
}

const makeSettings = ({ mute = false, popupMessage = false, popupIllust = true, popupUser = true, pressureColor = DEFAULT_PRESSURE, pressureWeight = DEFAULT_PRESSURE, syncEraserBrush = false, stabilization = 2, taperStart = 0, taperEnd = 0, undoMax = 10 }: Partial<Settings> = {}): Settings => {
  pressureColor = Number.isFinite(pressureColor) ? Math.max(0, Math.min(10, Math.round(pressureColor))) : DEFAULT_PRESSURE
  pressureWeight = Number.isFinite(pressureWeight) ? Math.max(0, Math.min(10, Math.round(pressureWeight))) : DEFAULT_PRESSURE
  stabilization = Number.isFinite(stabilization) ? Math.max(0, Math.min(10, Math.round(stabilization))) : 0
  taperStart = Number.isFinite(taperStart) ? Math.max(0, Math.min(10, Math.round(taperStart))) : 0
  taperEnd = Number.isFinite(taperEnd) ? Math.max(0, Math.min(10, Math.round(taperEnd))) : 0
  undoMax = Number.isFinite(undoMax) ? Math.max(5, Math.min(50, Math.round(undoMax))) : 10
  return reactive({ mute, popupMessage, popupIllust, popupUser, pressureColor, pressureWeight, syncEraserBrush, stabilization, taperStart, taperEnd, undoMax })
}
const getSettings = (): Settings => {
  try {
    const json = localStorage.getItem(KEY)
    const settings = json ? makeSettings(migrateSettings(JSON.parse(json))) : makeSettings()
    localStorage.setItem(KEY, JSON.stringify(settings))
    return settings
  } catch (error) {
    localStorage.removeItem(KEY)
    return makeSettings()
  }
}
const settings = getSettings()
const save = () => localStorage.setItem(KEY, JSON.stringify(settings))

watch(settings, save)

export default settings
